<template>
  <div class="page-container">
    <!-- Header -->
    <header class="header-section">
      <div class="header-left">
        <img src="@/assets/logo.png" alt="AReel" class="header-logo-img" />
      </div>
      <div class="header-right">
        <a href="/privacy.html" class="header-link">Privacy Agreement</a>
        <a href="https://wa.me/85265896001" target="_blank" rel="noopener noreferrer" class="header-whatsapp">
          <img src="@/assets/icon_whatsapp.png" alt="WhatsApp" class="header-whatsapp-icon" />
          <span class="header-phone">+852 65896001</span>
        </a>
        <button class="btn-contact">Contact</button>
      </div>
    </header>

    <!-- Hero Section -->
    <section class="section-hero">
      <img src="@/assets/img_hero_bg.png" alt="" class="hero-bg-img" />
      <div class="hero-content">
        <div class="hero-text-block">
          <h1 class="hero-title">
            Unleash Non<br/>-Stop Fun
          </h1>
          <p class="hero-subtitle">
            Watch the most exciting short dramas anytime, anywhere. Your daily dose of entertainment starts here.
          </p>
        </div>
      </div>
    </section>

    <!-- Showcase Section -->
    <section class="section-showcase">
      <div class="showcase-phone">
        <img src="@/assets/img_phone.png" alt="App Preview" class="showcase-phone-img" />
      </div>
      <h2 class="showcase-title">
        Join The Fun And Watch Your<br/>Favorite Shows Today!
      </h2>
    </section>

    <!-- Footer Section -->
    <section class="section-footer">
      <img src="@/assets/img_footer_bg.png" alt="" class="footer-bg-img" />
      <div class="footer-overlay"></div>
      <div class="footer-content">
        <p class="footer-subtitle">Install now</p>
        <h2 class="footer-title">
          Don't Miss Out<br/>on The Fun
        </h2>

        <!-- Agreement Links -->
        <div class="footer-links">
          <a href="/useragreement.html" target="_blank" rel="noopener noreferrer">User Agreement</a>
          <span class="footer-links-separator">|</span>
          <a href="/privacypolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        </div>

        <!-- Contact Info -->
        <div class="footer-contact">
          <div class="contact-item">
            <img src="@/assets/icon_mail.png" alt="" class="contact-icon" />
            <span>AbitGamemax@gmail.com</span>
          </div>
          <div class="contact-item">
            <img src="@/assets/icon_whatsapp.png" alt="" class="contact-icon" />
            <span>+852 65896001</span>
          </div>
          <div class="contact-item">
            <img src="@/assets/icon_company.png" alt="" class="contact-icon" />
            <span>Hong Kong EasyPoint Technology Limited</span>
          </div>
          <div class="contact-item">
            <img src="@/assets/icon_map.png" alt="" class="contact-icon" />
            <span>Room D07, 8/F, Kai Tak Factory Building Phase ll, 99 King Fuk Street, San Po Kong, Hong Kong</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
// Static landing page - no dynamic data needed
</script>

<style>
@import "tailwindcss";

@theme {
  --color-brand-dark: #0f0c29;
  --color-brand-purple: #302b63;
  --color-brand-blue: #24243e;
}

:root {
  --fluid-hero-title: clamp(3rem, 8vw + 1rem, 8rem);
  --fluid-hero-subtitle: clamp(0.875rem, 1.2vw + 0.6rem, 1.25rem);
  --fluid-section-title: clamp(2rem, 6vw + 0.5rem, 7rem);
  --fluid-footer-title: clamp(1.75rem, 4.5vw + 0.5rem, 3.75rem);
  --fluid-body: clamp(0.75rem, 1vw + 0.5rem, 0.875rem);
  --fluid-btn: clamp(0.875rem, 1vw + 0.5rem, 1rem);
  --fluid-contact: clamp(0.625rem, 0.8vw + 0.4rem, 0.75rem);
  --section-padding-x: 4%;
  --header-padding-x: 4%;
}

/* Base */
.page-container {
  min-height: 100vh;
  background-color: #050511;
  color: white;
  font-family: inherit;
  overflow-x: hidden;
  box-sizing: border-box;
}

.page-container *,
.page-container *::before,
.page-container *::after {
  box-sizing: border-box;
}

/* Header */
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 30;
  width: 100%;
  padding: clamp(1rem, 2.5vw, 1.5rem) clamp(1.5rem, 4vw, 3rem);
  background: transparent;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-logo-img {
  height: clamp(2rem, 4vw, 2.5rem);
  width: auto;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.header-link {
  display: none;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.875rem;
  text-decoration: none;
  transition: opacity 0.2s;
}

.header-link:hover {
  opacity: 0.7;
}

@media (min-width: 768px) {
  .header-link {
    display: inline;
  }
}

.header-whatsapp {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.85);
  transition: opacity 0.2s;
}

.header-whatsapp:hover {
  opacity: 0.7;
}

.header-whatsapp-icon {
  width: 1.25rem;
  height: 1.25rem;
  object-fit: contain;
}

.header-phone {
  display: none;
  font-size: 0.875rem;
}

@media (min-width: 768px) {
  .header-phone {
    display: inline;
  }
}

.btn-contact {
  background: white;
  color: #111;
  padding: 0.5rem 1.5rem;
  border-radius: 2rem;
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
}

.btn-contact:hover {
  opacity: 0.85;
}

/* Hero Section */
.section-hero {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.hero-bg-img {
  display: block;
  width: 100%;
  height: auto;
}

.hero-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 clamp(1.5rem, 5vw, 4rem);
}

.hero-text-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  z-index: 10;
  text-align: center;
}

@media (max-width: 768px) {
  .hero-text-block {
    max-width: 90%;
  }
}

.hero-title {
  font-size: clamp(2rem, 6vw, 5rem);
  font-weight: 700;
  line-height: 1.1;
  color: white;
}

.hero-subtitle {
  color: rgba(255, 255, 255, 0.75);
  font-size: clamp(0.875rem, 1.5vw, 1.125rem);
  line-height: 1.6;
}

/* Showcase Section */
.section-showcase {
  padding: clamp(4rem, 10vw, 8rem) 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.showcase-phone {
  display: flex;
  justify-content: center;
  margin-bottom: clamp(2rem, 5vw, 4rem);
}

.showcase-phone-img {
  width: clamp(400px, 80vw, 800px);
  height: auto;
}

.showcase-title {
  font-size: clamp(1.5rem, 4vw, 3.5rem);
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  color: #FFFFFD;
  padding: 0 1rem;
}

/* Footer Section */
.section-footer {
  position: relative;
  overflow: hidden;
}

.footer-bg-img {
  display: block;
  width: 100%;
  height: auto;
}

.footer-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0.75) 100%);
}

.footer-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: clamp(2rem, 5vw, 4rem) clamp(1rem, 3vw, 2rem);
  text-align: center;
}

.footer-subtitle {
  color: rgba(255,255,255,0.75);
  font-size: clamp(0.875rem, 1.5vw, 1.125rem);
  margin-bottom: 0.5rem;
}

.footer-title {
  font-size: clamp(1.75rem, 4.5vw, 3.5rem);
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
  margin-bottom: clamp(1.5rem, 3vw, 2.5rem);
}

.footer-links {
  margin-bottom: clamp(1.5rem, 3vw, 2.5rem);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  font-size: 0.8rem;
}

.footer-links a {
  color: rgba(255,255,255,0.7);
  text-decoration: none;
  padding: 0.35rem 1rem;
  border: 1px solid rgba(255,255,255,0.25);
  border-radius: 2rem;
  transition: all 0.2s ease;
}

.footer-links a:hover {
  color: #fff;
  border-color: rgba(255,255,255,0.6);
  background: rgba(255,255,255,0.08);
}

.footer-links-separator {
  color: rgba(255,255,255,0.3);
}

.footer-contact {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.75rem;
  color: rgba(255,255,255,0.6);
}

@media (min-width: 768px) {
  .footer-contact {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1.5rem;
  }
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.contact-icon {
  width: 1rem;
  height: 1rem;
  object-fit: contain;
  flex-shrink: 0;
}
</style>
